export { pointEnd, pointStart, position } from './lib/index.js';